import { getTypeDependedFieldInputProps } from 'app/shared/components/loanManagement/loanActionsGroup';

import { FieldType } from 'constants/formGenerator';
import { FieldTypesEnum, FieldTypesEnumToFieldTypeMapping } from 'constants/loanActionEditor';
import { getConditionalObject } from 'utils/data';
import { transformNameInModelIntoFormName } from 'utils/formGenerator';

import {
  LOAN_ACTION_RICH_TEXT_MAX_LENGTH,
  RICH_TEXT_EDITOR_RELATED_FIELDS,
} from '../LoanInfoHeader.constants';

import { getRichTextLoanActionFieldSchema } from './LoanActionModalForm.utils';

export const getFormConfigForLoanActionVariableFields = ({ fields, loanActionFieldsMap }) => {
  return {
    groups: [
      {
        type: FieldType.GROUP,
        key: 'loan-actions-group',
        fields: fields.map(({ name, required, fieldId }) => {
          const fieldData = loanActionFieldsMap[fieldId];
          const isRichTextField = RICH_TEXT_EDITOR_RELATED_FIELDS.includes(fieldData.key);
          const fieldType = isRichTextField
            ? FieldType.RICH_TEXTAREA
            : FieldTypesEnumToFieldTypeMapping[fieldData.type];

          return {
            type: fieldType,
            nameInModel: transformNameInModelIntoFormName(fieldId),
            key: fieldId,
            inputProps: {
              multiple: fieldData.type === FieldTypesEnum.MULTISELECT,
              key: `${fieldId}.input`,
              label: name,
              variant: 'outlined',
              required,
              ...getTypeDependedFieldInputProps(fieldData, 'loanActionVariable'),
              ...getConditionalObject(isRichTextField, {
                maxLength: LOAN_ACTION_RICH_TEXT_MAX_LENGTH,
                customSchema: getRichTextLoanActionFieldSchema,
              }),
            },
          };
        }),
      },
    ],
  };
};
